import { string } from "yup";
export var CheckoutText;
(function (CheckoutText) {
    CheckoutText["CHECKOUT"] = "Checkout";
    CheckoutText["TOTAL"] = "Total:";
    CheckoutText["SEE_ORDER_DETAILS"] = "See order details";
    CheckoutText["PLEASE_ACCEPT_TERMS"] = "Please accept the Terms and Conditions";
    CheckoutText["PLEASE_SELECT_ADDRESS"] = "Please select a delivery address";
    CheckoutText["PLEASE_SELECT_LOCATION"] = "Please select a pick up location";
    CheckoutText["PLEASE_SELECT_PAYMENT"] = "Please select a payment method";
    CheckoutText["PLEASE_SELECT_VALID_PAYMENT"] = "Please select a valid payment method";
    CheckoutText["PREVIOUS"] = "Previous";
    CheckoutText["PLACE_ORDER"] = "Place Order";
    CheckoutText["GO_TO_ACCOUNT"] = "Go to your account";
    CheckoutText["SOMETHING_WENT_WRONG_GENERIC"] = "Something went wrong while processing your order. Please try again.";
    CheckoutText["SOMETHING_WENT_WRONG_PAYMENT"] = "Something went wrong with your payment. Please try again.";
    CheckoutText["MUST_ADD_ADDRESS_TO_CONTINUE_HEADING"] = "Add Address";
    CheckoutText["MUST_ADD_ADDRESS_TO_CONTINUE_HELPER"] = "You've selected to have your meals delivered. Please enter your address below to continue.";
    CheckoutText["SWITCH_TO_PICKUP"] = "Switch to pick up";
    CheckoutText["NAVIGATION_WARNING_TITLE"] = "Leave Checkout?";
    CheckoutText["NAVIGATION_WARNING_MESSAGE_MARKDOWN"] = "You are about to leave the checkout page. Any progress on this order will be saved, but you'll need to return to complete your purchase.\n\n**Are you sure you want to leave?**";
    CheckoutText["STAY_ON_PAGE"] = "Stay on Page";
    CheckoutText["LEAVE_PAGE"] = "Leave Page";
})(CheckoutText || (CheckoutText = {}));
export const checkoutFormSchema = {
    paymentMethod: string().required(CheckoutText.PLEASE_SELECT_PAYMENT),
};
